import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ResourcesService } from '@libs/app.services/landing/resources.service';
import { LocalstorageService } from '@libs/app.services/landing/localstorage.service';

@Component({
  selector: 'app-logo',

  imports: [CommonModule, RouterModule],
  templateUrl: './app-logo.component.html',
  styleUrl: './app-logo.component.css',
})
export class AppLogoComponent {
  bichoEnabled = computed(() => this.resources.bichoEnabled());
  showApps = input<boolean>(false);
  constructor(
    public ls: LocalstorageService,
    private resources: ResourcesService,
  ) {}
}
